<template>
  <div class="calculator" :id="calculatorName">

    <div class="container">

      <div class="row justify-content-center">
        <div class="col-md-10 col-xl-8 mb-3">
          <div class="progress-container">
          <div class="progress-bar-bg">
            <div class="progress-bar-fill" :style="{ width: ((currentStep - 1) / (totalSteps - 1)) * 100 + '%' }"></div>
          </div>
        </div>

        <div class="step-nav-buttons mt-4 text-center">
              <button
                type="button"
                class="btn previous-step"
                @click="prevStep"
                v-if="currentStep != 1"
              >
                Back
              </button>
        </div>

        <div class="calculator-container">

          <div class="mt-3" @keyup="resetCalculation" @change="resetCalculation">

            <BooleanChoiceButtons
                fieldText="Number of Applicants"
                buttonTextLeft="1"
                buttonTextRight="2"
                v-if="currentStep === 1"
            >
              <template v-slot:left>
                <input type="radio" v-model="applicantsCount" :value=1 @click="clearApplicant2">
              </template>
              <template v-slot:right>
                <input type="radio" v-model="applicantsCount" :value=2>
              </template>
            </BooleanChoiceButtons>

            
              <div class="row mb-5" v-if="currentStep === 2">
                <h4 class="calc-fieldset-title">First Applicant</h4>
                <InputElement fieldText="Applicant 1 annual income (including benefits)?">
                  <InputTypeNumber currencyPlaceholder v-model="annualIncome1"/>
                </InputElement>
              </div>
            

              <div class="row mb-5" v-if="currentStep === 3">
                <h4 class="calc-fieldset-title">First Applicant Monthy Commitments</h4>
                <InputElement fieldText="HP (Hire purchase)">
                  <InputTypeNumber currencyPlaceholder v-model="hirePurchase1"/>
                </InputElement>

                
                  <InputElement
                      
                      fieldText="Loans"
                  >
                    <InputTypeNumber currencyPlaceholder v-model="loans1"/>
                  </InputElement>
                

                
                  <InputElement
                      fieldText="Student Loan"
                  >
                    <InputTypeNumber currencyPlaceholder v-model="studentLoan1"/>
                  </InputElement>
                

                
                  <InputElement
                      fieldText="Child Maintenance Payments"
                  >
                    <InputTypeNumber currencyPlaceholder v-model="childPayments1"/>
                  </InputElement>
                

                
                  <InputElement
                      fieldText="Credit Card Payments (min 3% outstanding balance)"
                  >
                    <InputTypeNumber currencyPlaceholder v-model="cardPayments1"/>
                  </InputElement>
                
              </div>
            

            
              <div class="row mb-5" v-if="currentStep === 4">
                <h4 class="calc-fieldset-title">Second Applicant</h4>
                <InputElement fieldText="Applicant 2 annual income (including benefits)?">
                  <InputTypeNumber currencyPlaceholder v-model="annualIncome2"/>
                </InputElement>
              </div>
            

            
              <div class="row mb-5" v-if="currentStep === 5">
                <h4 class="calc-fieldset-title">Second Applicant Monthy Commitments</h4>
                <InputElement fieldText="HP (Hire purchase)">
                  <InputTypeNumber currencyPlaceholder v-model="hirePurchase2"/>
                </InputElement>

                
                  <InputElement
                       fieldText="Loans"
                  >
                    <InputTypeNumber currencyPlaceholder v-model="loans2"/>
                  </InputElement>
                

                
                  <InputElement
                      fieldText="Student Loan"
                  >
                    <InputTypeNumber currencyPlaceholder v-model="studentLoan2"/>
                  </InputElement>
                

                
                  <InputElement
                      fieldText="Child Maintenance Payments"
                  >
                    <InputTypeNumber currencyPlaceholder v-model="childPayments2"/>
                  </InputElement>
                

                
                  <InputElement
                      fieldText="Credit Card Payments (min 3% outstanding balance)"
                  >
                    <InputTypeNumber currencyPlaceholder v-model="cardPayments2"/>
                  </InputElement>
                
              </div>
            

            
            <div class="row mb-5" v-if="currentStep === 6">
              <div class="col-12 label">Why are you using the calculator today?</div>
              <div class="col-12">
                <MultiplyChoiceButton
                    buttonText="I’m ready to get a mortgage"
                >
                  <input type="radio" v-model="calcReason1" value="I’m ready to get a mortgage">
                </MultiplyChoiceButton>
                <MultiplyChoiceButton
                    buttonText="I’m curious to know what I can borrow"
                >
                  <input type="radio" v-model="calcReason1" value="I’m curious to know what I can borrow">
                </MultiplyChoiceButton>
                <MultiplyChoiceButton
                    buttonText="I want to understand what I can afford before I search for a home"
                >
                  <input type="radio" v-model="calcReason1" value="I want to understand what I can afford before I search for a home">
                </MultiplyChoiceButton>
              </div>
            </div>

            <div class="row mb-5" v-if="currentStep === 7">
              <div class="col-12 label">When are you hoping to move?</div>
              <div class="col-12">
                <MultiplyChoiceButton
                    buttonText="As soon as possible"
                >
                  <input type="radio" v-model="calcReason2" value="As soon as possible">
                </MultiplyChoiceButton>
                <MultiplyChoiceButton
                    buttonText="In the next 3 months"
                >
                  <input type="radio" v-model="calcReason2" value="In the next 3 months">
                </MultiplyChoiceButton>
                <MultiplyChoiceButton
                    buttonText="6-12 months from now"
                >
                  <input type="radio" v-model="calcReason2" value="6-12 months from now">
                </MultiplyChoiceButton>
                <MultiplyChoiceButton
                    buttonText="12+ months from now"
                >
                  <input type="radio" v-model="calcReason2" value="12+ months from now">
                </MultiplyChoiceButton>
              </div>
            </div>
            
            <div class="step-nav-buttons mt-4 text-center">
              <button
                type="button"
                class="btn next-step"
                @click="nextStep"
                v-if="currentStep != totalSteps - 1 && currentStep != 8"
                :disabled="!isStepValid"
              >
                Next
              </button>

              <button
                type="button"
                class="btn calculate"
                v-if="currentStep === totalSteps - 1"
                @click="calculate"
                :disabled="!isStepValid"
              >
                Calculate
              </button>
            </div>

          </div>

          <div v-if="currentStep === 8" ref="resultsContainer">

              <ResultsContainer class="mt-5 mb-5 calc-results-box">
                <div class="mb-3 results-title">You may be able to borrow:</div>
                <span class="fcs-price">£{{ formatNumberOutput(requiredLoanValue) }}</span>
                <div class="content mt-3">Please submit your details below to obtain your most suitable advice on mortgage
                  affordability and the most suitable rates.
                </div>
              </ResultsContainer>

              <SubmissionForm :calculatorName="calculatorName" :calculatorData="collateMessageBody"/>

          </div>

        </div>
        </div>
      </div>

    </div>

  </div>
</template>

<script>
import BooleanChoiceButtons from '@/components/utilities/booleanChoiceButtons.vue'
import InputElement from '@/components/utilities/inputElement.vue'
import InputTypeNumber from '@/components/utilities/inputTypeNumber.vue'
import ResultsContainer from '@/components/utilities/resultsContainer.vue'
import SubmissionForm from '@/components/utilities/submissionForm.vue'
import MultiplyChoiceButton from '@/components/utilities/multiplyChoiceButton.vue'
import axios from "axios"

export default {
  components: {
    BooleanChoiceButtons,
    InputElement,
    InputTypeNumber,
    ResultsContainer,
    MultiplyChoiceButton,
    SubmissionForm
  },
  data() {
    return {
      currentStep: 1,
      totalSteps: 8,
      calculatorName: 'remortgage-calculator',
      applicantsCount: 0,

      annualIncome1: null,
      hirePurchase1: null,
      loans1: null,
      studentLoan1: null,
      childPayments1: null,
      cardPayments1: null,

      annualIncome2: null,
      hirePurchase2: null,
      loans2: null,
      studentLoan2: null,
      childPayments2: null,
      cardPayments2: null,

      requiredLoanValue: 0,
      calcCompleted: false,
      calculatorReasonTitle: null,
      calculatorReasonResults: null,
      calcReason1: "",
      calcReason2: "",
      listName: "",
      emailAddress: "",
      consent: "",
      submissionReason: {
        submitted: false,
        is_valid: false,
        confirmation_message: ''
      },
      submissionList: {
        submitted: false,
        is_valid: false,
        confirmation_message: ''
      },
      formErrors: [],
      gfid: 6, //Please check the Gravity Form for corresponding form id (staging and live may vary!)
      gfidlist: 9 //Please check the Gravity Form for corresponding form id (staging and live may vary!)
    }
  },
  methods: {
    calculate() {
      if (this.currentStep < this.totalSteps) {
          this.currentStep++;
      }
      let requiredLoanValue1
      let requiredLoanValue2
      this.applicantsCount > 0 ? requiredLoanValue1 = ((this.annualIncome1 - ((this.hirePurchase1 + this.loans1 + this.studentLoan1 + this.childPayments1 + this.cardPayments1) * 12)) * 5.5) : requiredLoanValue1 = 0
      this.applicantsCount == 2 ? requiredLoanValue2 = ((this.annualIncome2 - ((this.hirePurchase2 + this.loans2 + this.studentLoan2 + this.childPayments2 + this.cardPayments2) * 12)) * 5.5) : requiredLoanValue2 = 0
      this.requiredLoanValue = requiredLoanValue1 + requiredLoanValue2
      this.calcCompleted = true;
      this.calculatorReasonTitle = this.removeHyphensToUpperCase(this.calculatorName);
      this.calculatorReasonResults = 
      `
      Why are you using the calculator today: ${this.calcReason1}
      When will you be ready to move forward: ${this.calcReason2}
      `;
      this.calculatorListName = this.listName;
      this.calculatorEmailAddress = this.emailAddress;
      this.calculatorConsent = this.consent;
      this.$nextTick(() => {
        const resultsContainer = this.$refs.resultsContainer;

        if (resultsContainer) {
            // Get the bounding rectangle of the element
            const rect = resultsContainer.getBoundingClientRect();

            // Calculate the target scroll position
            const targetScrollPosition = window.scrollY + rect.top - 200;

            // Scroll to the target position
            window.scrollTo({
                top: targetScrollPosition,
                behavior: 'smooth'
            });
        } else {
            console.error('resultsContainer is undefined');
        }
      });
      var newReasonSubmission = new FormData();
      var newListSubmission = new FormData();

      newReasonSubmission.append("form_id", this.gfid); //Please check the Gravity Form form id (staging and live may vary!)
      newReasonSubmission.append("input_1", this.calculatorReasonTitle);
      newReasonSubmission.append("input_3", this.calculatorReasonResults);

      newListSubmission.append("form_id", this.gfidlist); //Please check the Gravity Form form id (staging and live may vary!)
      newListSubmission.append("input_1", this.calculatorListName);
      newListSubmission.append("input_3", this.calculatorEmailAddress);
      newListSubmission.append("input_4.1", this.calculatorConsent ? 1 : 0);

      this.postReasonSubmission(newReasonSubmission);
      this.postListSubmission(newListSubmission);
    },
    async postReasonSubmission(submissionReasonData) {
      try {
        const response = axios.post('/wp-json/gf/v2/forms/8/submissions', submissionReasonData, {
          headers: {
            "Content-type": "application/json; charset=UTF-8",
          },
        });
        const submissionReason = response;
        
        this.submissionReason.is_valid = submissionReason.is_valid;
        this.submissionReason.confirmation_message = submissionReason.confirmation_message;
        this.submissionReason.validation_messages = submissionReason.validation_messages;

      } catch(error) {
        console.log(error)
      }
    },
    async postListSubmission(submissionListData) {
      try {
        const response = axios.post('/wp-json/gf/v2/forms/9/submissions', submissionListData, {
          headers: {
            "Content-type": "application/json; charset=UTF-8",
          },
        });
        const submissionList = response;
        
        this.submissionList.is_valid = submissionList.is_valid;
        this.submissionList.confirmation_message = submissionList.confirmation_message;
        this.submissionList.validation_messages = submissionList.validation_messages;

      } catch(error) {
        console.log(error)
      }
    },
    clearApplicant2() {
      this.annualIncome2 = null,
          this.hirePurchase2 = null,
          this.loans2 = null,
          this.studentLoan2 = null,
          this.childPayments2 = null,
          this.cardPayments2 = null
    },
    resetCalculation() {
      this.calcCompleted = false
    },
    formatNumberOutput(number) {
      const newNumber = (new Intl.NumberFormat('en-GB').format(number))
      if ( newNumber === 'NaN' ) { return 0 } return newNumber
    },
    removeHyphensToUpperCase(str) {
      return str.replace(/(-|^)([^-]?)/g, function(_, prep, letter) { return (prep && ' ') + letter.toUpperCase(); });
    },
    formatEmptyMessageFields(message){
      return message ? message : 'N/A'
    },
    nextStep() {
      if (this.currentStep === 3 && this.applicantsCount === 1) {
        this.currentStep = 6;
        return;
      }

      // Default increment
      if (this.currentStep < this.totalSteps) {
        this.currentStep++;
      }
    },
    prevStep() {
      if (this.currentStep === 6 && this.applicantsCount === 1) {
        this.currentStep = 3;
        return;
      }

      if (this.currentStep === 8) {
        this.currentStep = 7;
        return;
      }

      if (this.currentStep > 1) {
        this.currentStep--;
      }
    },
  },
  computed: {
    /**
     * Show button if previous section is completed
     * @return {Bool}
     */
    isStepValid() {
      if (this.currentStep === 1) {
        return this.applicantsCount === 1 || this.applicantsCount === 2;
      }
      if (this.currentStep === 2) {
        return this.annualIncome1 > 0;
      }
      return true;
    },
    showListFields() {
      let listFields
      if ( this.applicantsCount < 1 ) { return listFields = false }
      this.applicantsCount == 1
          ? ( this.annualIncome1 > 0 && this.hirePurchase1 !== null && this.loans1 !== null && this.studentLoan1 !== null && this.childPayments1 !== null && this.cardPayments1 !== null ) ? listFields = true : listFields = false
          : ( this.annualIncome2 > 0 && this.hirePurchase2 !== null && this.loans2 !== null && this.studentLoan2 !== null && this.childPayments2 !== null && this.cardPayments2 !== null ) && ( this.annualIncome1 !== null && this.hirePurchase1 !== null && this.loans1 !== null && this.studentLoan1 !== null && this.childPayments1 !== null && this.cardPayments1 !== null ) ? listFields = true : listFields = false
      return listFields
    },
    showCalculateButton() {
      let calculateButton
      if ( this.applicantsCount < 1 ) { return calculateButton = false }
      this.applicantsCount == 1
          ? ( this.annualIncome1 > 0 && this.hirePurchase1 !== null && this.loans1 !== null && this.studentLoan1 !== null && this.childPayments1 !== null && this.cardPayments1 !== null ) ? calculateButton = true : calculateButton = false
          : ( this.annualIncome2 > 0 && this.hirePurchase2 !== null && this.loans2 !== null && this.studentLoan2 !== null && this.childPayments2 !== null && this.cardPayments2 !== null ) && ( this.annualIncome1 !== null && this.hirePurchase1 !== null && this.loans1 !== null && this.studentLoan1 !== null && this.childPayments1 !== null && this.cardPayments1 !== null ) ? calculateButton = true : calculateButton = false
      return calculateButton
    },
    householdIncome() {
      let annualIncome1 = this.annualIncome1 ? this.annualIncome1 : 0;
      let annualIncome2 = this.annualIncome2 ? this.annualIncome2 : 0;

      return annualIncome1 + annualIncome2;
    },
    collateMessageBody() {
      const calculatorData =
          {
            calculatorTitle: this.removeHyphensToUpperCase(this.calculatorName),
            calculatorResults:
                `
					Applicant 1
                        Annual Income: £${this.formatEmptyMessageFields(this.annualIncome1)}
                        HP (Hire purchase): £${this.formatEmptyMessageFields(this.hirePurchase1)}
                        Loans: £${this.formatEmptyMessageFields(this.loans1)}
                        Student Loan: £${this.formatEmptyMessageFields(this.studentLoan1)}
                        Child Maintenance Payments £${this.formatEmptyMessageFields(this.childPayments1)}
                        Credit Card Payments: £${this.formatEmptyMessageFields(this.cardPayments1)}
                    Applicant 2
                        Annual Income: £${this.formatEmptyMessageFields(this.annualIncome2)}
                        HP (Hire purchase): £${this.formatEmptyMessageFields(this.hirePurchase2)}
                        Loans: £${this.formatEmptyMessageFields(this.loans2)}
                        Student Loan: £${this.formatEmptyMessageFields(this.studentLoan2)}
                        Child Maintenance Payments £${this.formatEmptyMessageFields(this.childPayments2)}
                        Credit Card Payments: £${this.formatEmptyMessageFields(this.cardPayments2)}
                    Household Annual Income: £${this.householdIncome}
                    Required Loan Value: £${this.requiredLoanValue}
                    Why are you using the calculator today: ${this.calcReason1}
          When will you be ready to move forward: ${this.calcReason2}
                `
          }
      return calculatorData;
    }
  }
}
</script>

<style lang="scss">
@import './styles/calcs.scss';
</style>